<template>
  <div class="talent-recruitment">
    <div class="banner">
      <img src="../../assets/img/talentRecruitment/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("talentDevelopment.banner.bannerTitle")}}</h1>
          <p>{{$t("talentDevelopment.banner.bannerP")}}</p>
        </div>
      </div>
    </div>
    <div class="container main">
      <el-tabs v-model="activeName"  @tab-click="handleClick">
          <el-tab-pane :label="$t('talentRecruitment.tabs.society')" name="1">
            <div class="society">
              <el-table
                :data="tableData.filter(data => data.states)"
                style="width: 100%"
                >
                  <el-table-column type="expand" >
                    <template slot-scope="props">
                      <el-form label-position="left" class="demo-table-expand" >
                        <el-form-item :label="$t('talentRecruitment.tabs.mainWork')">
                          <div v-html="props.row.mainWork.replace(/\r?\n/g, '<br>')"></div>
                        </el-form-item>
                        <el-form-item :label="$t('talentRecruitment.tabs.baseDemand')">
                          <div v-html="props.row.baseDemand.replace(/\r?\n/g, '<br>')"></div>
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" class="mt20" @click.native="showForm( props.row.postNo)">{{$t('talentRecruitment.tabs.btn')}}</el-button>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('talentRecruitment.tabs.postName')" prop="postName" >
                  </el-table-column>
                  <el-table-column
                    :label="$t('talentRecruitment.tabs.userNum')"
                    prop="userNum" >
                  </el-table-column>
                  <el-table-column
                    :label="$t('talentRecruitment.tabs.workArea')"
                    prop="workArea" >
                  </el-table-column>
                  <el-table-column
                    :label="$t('talentRecruitment.tabs.wages')"
                    prop="wages">
                  </el-table-column>
                  <el-table-column
                    :label="$t('talentRecruitment.tabs.createTime')"
                    prop="createTime" >
                  </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('talentRecruitment.tabs.partTime')" name="2">
            <div class="part-time">
              <el-table
                :data="tableData.filter(data => data.states)"
                style="width: 100%"
                >
                  <el-table-column type="expand" >
                    <template slot-scope="props">
                      <el-form label-position="left" class="demo-table-expand" >
                        <el-form-item :label="$t('talentRecruitment.tabs.mainWork')">
                          <span>{{ props.row.mainWork }}</span>
                        </el-form-item>
                        <el-form-item :label="$t('talentRecruitment.tabs.baseDemand')">
                          <span>{{ props.row.baseDemand }}</span>
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" class="mt20" @click.native="showForm( props.row.postNo)">{{$t('talentRecruitment.tabs.btn')}}</el-button>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('talentRecruitment.tabs.postName')" prop="postName" >
                  </el-table-column>
                  <el-table-column
                    :label="$t('talentRecruitment.tabs.userNum')"
                    prop="userNum" >
                  </el-table-column>
                  <el-table-column
                    :label="$t('talentRecruitment.tabs.workArea')"
                    prop="workArea" >
                  </el-table-column>
                  <el-table-column
                    :label="$t('talentRecruitment.tabs.wages')"
                    prop="wages" >
                  </el-table-column>
                  <el-table-column
                    :label="$t('talentRecruitment.tabs.createTime')"
                    prop="createTime" >
                  </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog
      :title="$t('talentRecruitment.updataForm.title')"
      :visible.sync="dialogForm"
      width="360px"
    >
      <div class="dialog-form">
        <div class="pic-wrap">
          <img src="../../assets/img/talentRecruitment/file1.png" alt="" class="mb10">
          <el-upload
            class="upload-demo"
            action="#"
            :auto-upload="false"
            :on-change="handleUpload"
            :file-list="fileList"
            :on-remove="handleRemove"
            
            accept=".doc, .pdf, .ppt"
            ref="upload"
            >
            <!-- :on-exceed="handleExceed" -->
            <el-button size="mini" type="primary">{{$t('talentRecruitment.updataForm.updataBtn')}}</el-button>
            <div slot="tip" class="el-upload__tip">只能上传.doc, .pdf, .ppt文件，且不超过50mb</div>
          </el-upload>
        </div>
        
        <!-- <div>{{$t('talentRecruitment.updataForm.type')}}</div> -->

        <img src="../../assets/img/talentRecruitment/file2.png" alt="" class="mt20 mb20">
        
        <el-button type="primary" class="mt20" @click.native="submitForm">{{$t('talentRecruitment.updataForm.submitBtn')}}</el-button>
      </div>  

    </el-dialog>

  </div>
</template>

<script>
import { gangweiList, submitReporter ,uploadFile } from "../../api/talentRecruitment"
import { mapGetters } from "vuex";
export default {
  name: "TalentRecruitment",
  computed:{
    ...mapGetters(['language']),
  },
  data() {
    return {
      activeName:this.$route.params.id || "1",
      dialogForm:false,
      tableData:[],
      page:0,
      size:1000,
      fileList: [],
      filenos:[],
      postNo:''
    };
  },
  mounted() {
    var options = { live: false };
    new this.$wow.WOW(options).init();
    this.getLists();
    
  },
  methods: {
    getLists(){
      gangweiList(this.language,{postType:this.activeName,page:this.page,size:this.size}).then(res =>{
        this.tableData = res.data;
      })
    },
    handleClick(tab, event) {
        console.log(tab, event);
        if(tab.index==='0'){
          this.activeName='1';
        }else{
          this.activeName='2';
        }
        this.getLists();
    },
    showForm(postNo){
      this.postNo = postNo;
      this.dialogForm=true;
      this.fileList=[];
      this.filenos=[];
    },
    submitForm(){ 
      if(this.filenos.length){
        const data={
          sayType : '3',       //类型：1投诉举报、2联系我们、3简历投递
          fileNos: this.filenos,       //上传举报材料
          postNo: this.postNo
        }
        submitReporter(this.language,data).then(res =>{
          this.dialogForm=false;
          this.$refs.upload.clearFiles();
          return this.$message.success(res.msg);
        })
      }else{
        this.$refs.upload.clearFiles();
        return this.$message.error('文件不能为空');
      }
      
    },
    // 文件上传
    handleUpload(file){
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        return this.$message.error('上传文件大小不能超过 50MB!');
      }
      uploadFile(this.language,file.raw).then(res => {
        const { createTime, fileName, fileNo, fileUrl, extension } = res.data
        res.data.name = fileName
        this.fileList.push(res.data);
        this.filenos.push(fileNo);
      })
    },
    handleRemove(file, fileList) {
      const index=this.fileList.findIndex(item => item.uid=== file.uid);
      this.fileList.splice(index, 1);
      this.filenos.splice(index, 1);
    },
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制只能选择 1 个文件`);
    // },

  }
};
</script>

<style scoped lang="scss">
$cblue: #0054A7;
.talent-recruitment{
  .main{
    margin-top:-10%;
    background:#fff;
    border-radius: 16px; 
    padding:50px;
    box-shadow: 0 0 4px rgba(0,0,0,0.5);
    ::v-deep .el-tabs__active-bar {
      width: 36px;
    }
    ::v-deep .el-tabs__item {
      font-size: 18px;
    }
    ::v-deep .el-tabs__nav-wrap::after {
        background-color: transparent; 
    }
    ::v-deep .el-tabs__header{
      margin-bottom: 30px;
    }
    ::v-deep .has-gutter tr th {
        color: #fff;
        background:$cblue;
        font-weight: 500;
    }
    .demo-table-expand {
      .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        ::v-deep .el-form-item__label{
          display: block;
          float:none;
        }
      }
    }
  }
  .dialog-form{
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding-bottom: 20px;
    .pic-wrap{
      text-align: center;
    }
  }
    @media screen and (max-width:768px){
      .main{
        margin-top:0;
        padding:20px;
      }
    }
}

</style>
